import { Alert, Button, Stack } from '@mui/material';
import { PRICING_URL } from './demoLinks.ts';

/** Top of every page in a demo session: what this is, and what is switched off. */
const DemoBanner = () => (
  <Alert severity="info" sx={{ mt: 1, mb: 2, '& .MuiAlert-message': { flex: 1, minWidth: 0 } }}>
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1}
      sx={{ alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between' }}
    >
      <span>
        This is a shared demo that resets every hour, so do not enter real client information.
        Email, mailbox connections and uploads are turned off.
      </span>
      <Button
        color="inherit"
        size="small"
        variant="outlined"
        href={PRICING_URL}
        target="_blank"
        rel="noopener"
        sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
      >
        See pricing
      </Button>
    </Stack>
  </Alert>
);

export default DemoBanner;
